import Vue from 'vue'
import Vuex from 'vuex'
import {
    getMenu,
    getAddressData,
    getCountryOptions
} from '@/requests/system'
Vue.use(Vuex)

const config = {
    state: {
        // 当前用户信息
        user: {},
        // pda信息
        pda: {},
        // 版本信息
        version: {
            version: '',
            sprint: '',
            project_code: '',
            full_verison: ''
        },
        // 系统信息（服务器时间）
        system: {
            time: 0
        },
        // 流程配置
        exec: {},
        // 按钮权限
        btnauth: {},
        // 菜单
        menu: [],
        // 信息（红柚或医院）
        information: {},
        // 接口错误日志
        apiError: {},
        // 语言可选项
        langOptions: [],
        // 地址选项
        addressOptions: [],
        // 国家选项
        countries: []
    },
    mutations: {
        setUser(state, user) {
            Object.assign(state.user, user)
        },
        setPda(state, pda) {
            Object.assign(state.pda, pda)
        },
        setVersion(state, version) {
            Object.assign(state.version, version)
        },
        setSystem(state, system) {
            Object.assign(state.system, system)
        },
        setExec(state, exec) {
            state.exec = exec
        },
        setBtnauth(state, btnauth) {
            state.btnauth = btnauth
        },
        setMenu(state, menu) {
            state.menu = menu
        },
        setInformation(state, information) {
            state.information = information
        },
        setApiError(state, error = { path : '', msg : '' }) {
            const { apiError } = state
            const { path, msg } = error
            const msgs = apiError[path] || []
            msgs.push(msg)
            apiError[path] = msgs

            state.apiError = apiError
        },
        setLangOptions(state, opts) {
            state.langOptions = opts
        },
        setAddressOptions(state, data) {
            state.addressOptions = data
        },
        setCountries(state, data) {
            state.countries = data
        }
    },
    actions: {
        setUser: ({commit}, user) => commit('setUser', user),
        setPda: ({commit}, pda) => commit('setPda', pda),
        setVersion: ({commit}, version) => commit('setVersion', version),
        setSystem: ({commit}, system) => commit('setSystem', system),
        setExec: ({commit}, exec) => commit('setExec', exec),
        setBtnauth: ({commit}, btnauth) => commit('setBtnauth', btnauth),
        setMenu: ({ commit, state }) => {
            return new Promise(resolve => {
                if (state.menu && state.menu.length) {
                    resolve(state.menu)
                } else {
                    getMenu().then(res => {
                        if (!res) {
                            resolve(null)
                        }
    
                        commit('setMenu', res)
                        resolve(res)
                    })
                }
            })
        },
        setInformation: ({commit}, information) => commit('setInformation', information),
        setApiError: ({commit}, error) => commit('setApiError', error),
        setLangOptions: ({commit}, opts) => commit('setLangOptions', opts),
        setAddressOptions: ({ commit, state }) => {
            return new Promise(resolve => {
                if (state.addressOptions && state.addressOptions.length) {
                    resolve(state.addressOptions)
                } else {
                    getAddressData()
                    .then(res => {
                        const addressOptions = res || []
                        commit('setAddressOptions', addressOptions)

                        resolve(addressOptions)
                    })
                }
            })
        },
        setCountries: ({ commit, state }) => {
            return new Promise(resolve => {
                if (state.countries && state.countries.length) {
                    resolve(state.countries)
                } else {
                    getCountryOptions()
                    .then(res => {
                        const countries = res || []
                        commit('setCountries', countries)

                        resolve(countries)
                    })
                }
            })
        }
    },
    getters: {
        user: (state) => state.user,
        pda: (state) => state.pda,
        version: (state) => state.version,
        system: (state) => state.system,
        exec: (state) => state.exec,
        btnauth: (state) => state.btnauth,
        menu: (state) => state.menu,
        information: (state) => state.information,
        apiError: (state) => state.apiError,
        langOptions: (state) => state.langOptions,
        addressOptions: (state) => state.addressOptions,
        countries: (state) => state.countries
    },
}

const store = new Vuex.Store(config)

export default store